'use client'
import React, { useEffect, useState } from 'react';
import FilterSelect from '@/components/atoms/FilterSelect/FilterSelect';
import { StatType } from '@/types/types';
import { useTranslations } from 'next-intl';

interface StatTypeFilterProps {
  onFilterChange: (filter: { statType: StatType | "" }) => void;
  statType: StatType | "";
  availableStatTypes?: StatType[];
  disabled?: boolean;
}

const StatTypeFilter: React.FC<StatTypeFilterProps> = ({ onFilterChange, statType, availableStatTypes, disabled }) => {
  const [selectedType, setSelectedType] = useState<StatType | "">(statType);

  const f = useTranslations('filter');

  const statTypeOptions = [
    { value: '', label: f('all') },
    { value: 'results', label: f('result') },
    { value: 'goals', label: f('goals') },
    { value: 'btts', label: f('btts') },
    { value: 'corners', label: f('corners') },
    { value: 'cards', label: f('cards') },
    { value: 'totalShots', label: f('totalShots') },
    { value: 'onShots', label: f('onShots') }
  ];

  useEffect(() => {
    setSelectedType(statType);
  }, [statType]);

  const handleChange = (value: string | number) => {
    onFilterChange({ statType: value as StatType});
    setSelectedType(value as StatType);
  };
  let filteredOptions = statTypeOptions;
  if(availableStatTypes) {
    filteredOptions = statTypeOptions.filter(option => availableStatTypes.includes(option.value as StatType));
  }

  return (
    <FilterSelect
      label={f("stat")}
      options={filteredOptions}
      onChange={handleChange}
      value={selectedType}
      disabled={disabled}
    />
  );
};

export default StatTypeFilter;

